<template lang="pug">

  div

    //-
      - Modal AVISO
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //-
      - Modal SEARCH USER AND INVITE
      -

    v-dialog(v-model="visible" max-width="500px" :persistent="loading")

      .dialogHeader

        .dialogHeaderTitle
          | Informe o e-mail do usuário
        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeAddOrInviteUser()")

      .dialogBody

        .dialogBodyContent

          //- BUSCA

          .searchBlock
            v-icon(size="18" class="searchFieldIcon") mdi-magnify
            input(type="text" v-model="newUserEmail" :disabled="loading" maxlength="64" title="Digite entre 3 e 64 caracteres" placeholder="Digite um E-mail" class="searchField")

            .searchLoading(v-if="isEmailValid && loading")
              v-progress-circular(indeterminate color="red" size="25")

          sos-button(:disabled="loading || !isEmailValid" class="mt-5" @buttonClick="checkUserExists()" buttonLabel="Buscar" color="purple" size="medium" buttonIcon="mdi-magnify" buttonIconSize="20")

          //- RESULTADO DA BUSCA

          //-
            -------------------------------------------------------------------------------------
            - USUÁRIO NÃO ENCONTRADO
            -------------------------------------------------------------------------------------
            - OS GESTORES PODERÃO "CRIAR O USUÁRIO ?"
            -------------------------------------------------------------------------------------
            -

          .mt-5(v-if="foundUserProfileStatus === 'CREATE_AND_ADD_TO_GROUP'")

            .foundUserTitle
              | Usuário não encontrado.
              br
              //- | Preencha alguns dados dele, pois um convite será enviado para o e-mail:
              | Preencha alguns dados dele, pois a conta será criada:

            .searchBlock.mt-3
              v-icon(size="18" class="searchFieldIcon") mdi-account
              input(v-model="newUserName" type="text" class="searchField" maxlength="64" placeholder="Nome completo")

            .searchBlock.mt-3
              v-icon(size="18" class="searchFieldIcon") mdi-lock
              input(v-model="newUserPassword" type="text" class="searchField" maxlength="20" placeholder="Senha provisória")

            .searchBlock.mt-3
              v-icon(size="18" class="searchFieldIcon") mdi-doctor
              input(v-model="newUserCrm" type="text" class="searchField" maxlength="32" placeholder="CRM/COREN (Opcional)")

            .nota
              span Importante
              | : Compartilhe essa senha com o usuário. Informe que a senha é provisória e ele(a) pode muda-la no aplicativo.

          //-
            -------------------------------------------------------------------------------------
            - USUÁRIO ENCONTRADO
            -------------------------------------------------------------------------------------
            - OS GESTORES PODERÃO ADICIONAR O USUÁRIO NO GRUPO, CASO ELE AINDA NÃO FAÇA PARTE.
            -------------------------------------------------------------------------------------
            -

          .mt-5(v-else-if="foundUserProfileStatus === 'ADD_TO_GROUP' || foundUserProfileStatus === 'GROUP_MEMBER'")

            .foundUserTitle(v-if="foundUserProfileStatus === 'GROUP_MEMBER'")
              | Usuário encontrado e já está no grupo.
            .foundUserTitle(v-else)
              | Usuário encontrado, mas não está no grupo:

            .foundUserWrapper
              .foundUser--image(:style="{ backgroundImage: 'url(' + foundUserProfile.img + ')'}")
              .foundUser--data
                .data
                  b Nome:&nbsp;
                  span {{ foundUserProfile.nome || 'SEM NOME' }}
                .data
                  b E-mail:&nbsp;
                  span {{ foundUserProfile.email || 'SEM E-MAIL'}}

          //-
            -------------------------------------------------------------------------------------
            - BOTÃO PARA CONVIDAR USUÁRIO ou ADICIONAR NO GRUPO
            -------------------------------------------------------------------------------------
            -

          template(v-if="foundUserProfileStatus === 'ADD_TO_GROUP' || foundUserProfileStatus === 'CREATE_AND_ADD_TO_GROUP'")

            sos-button(
              :disabled="loading"
              @buttonClick="inviteOrAddUser()"
              :buttonLabel="foundUserProfileStatus === 'CREATE_AND_ADD_TO_GROUP' ? 'Criar conta' : 'Adicionar no grupo'"
              color="success"
              size="medium"
              buttonIcon="mdi-account-plus"
              buttonIconSize="20").mt-5

</template>

<script>

  import { getUserByUserID, apiGetUserIdByEmail } from '@/services/firebase'
  import { apiAddUserToGroup, apiCreateUser } from '@/services/users'

  import { /* firebaseErrorMessages, */ translateAuthError } from '@/functions'
  import { isEmailValid } from '@/utils.js'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import userProfileBroken from '@/assets/images/user-profile-broken.png'

  import SosButton from '@/components/SosButton'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  //
  //
  //

  export default {
    name: 'SearchUserAndInvite',

    components: {
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      // StringMixin,
      // timeMixin,
      confirmDialogMixin,
    ],

    data () {
      return {
        visible: false,
        loading: false,

        foundUserProfileStatus: 'WAITING',
        foundUserProfile: null,

        newUserEmail: '',
        newUserName: '',
        newUserPassword: '',
        newUserCrm: '',

        groupID: '',
      }
    },

    //
    //
    //

    computed: {
      isEmailValid: function () {
        return isEmailValid(this.newUserEmail)
      },

      newUserEmailLowerCase: function () {
        return String(this.newUserEmail).trim().toLowerCase()
      },
    },

    //
    //
    //

    watch: {
      visible: {
        // the callback will be called immediately after the start of the observation
        handler (currentState, _)
        {
          if (currentState === false) this.clearComponentState()
        },
      },

      newUserEmail: {
        handler (current, previous)
        {
          if (
            String(current) !== String(previous) && (
              this.newUserName.length > 0 ||
              this.newUserPassword.length > 0 ||
              this.newUserCrm.length > 0 ||
              this.foundUserProfileStatus !== 'WAITING' ||
              this.foundUserProfile !== null
            )
          )
          {
            // this.newUserEmail = ''
            this.newUserName = ''
            this.newUserPassword = ''
            this.newUserCrm = ''

            this.foundUserProfileStatus = 'WAITING'
            this.foundUserProfile = null

            // this.loading = false
          }
        },
      },
    },

    //
    //
    //

    methods: {
      //
      // GERENCIAR POPUP DE ADICIONAR / CONVIDAR USUÁRIO
      //

      open (args) {
        this.groupID = args.groupID
        this.visible = true
      },

      //
      // ?
      //

      cdAction (_) {
        //
      },

      //
      // ?
      //

      closeAddOrInviteUser () {
        if (this.loading) return false

        this.clearComponentState()
      },

      //
      // ?
      //

      clearComponentState ()
      {
        this.visible = false
        this.loading = false

        this.foundUserProfileStatus = 'WAITING'
        this.foundUserProfile = null

        this.newUserEmail = ''
        this.newUserName = ''
        this.newUserPassword = ''
        this.newUserCrm = ''

        this.groupID = ''
      },

      //
      // VERIFICA SE O E-MAIL INFORMADO JÁ ESTÁ CADASTRADO NO SISTEMA
      // Possivel bug CASE SENSITIVE - 05/07/2022
      //

      async checkUserExists ()
      {
        if (!this.isEmailValid)
        {
          this.foundUserProfileStatus = 'WAITING'
          this.foundUserProfile = null

          return false
        }

        this.loading = true

        const check = await apiGetUserIdByEmail(this.newUserEmailLowerCase)

        //
        // HOUVE ALGUM ERRO AO LER USUÁRIO
        //

        if (
          check.code === 0 &&
          (
            !Object.prototype.hasOwnProperty.call(check.data, 'code') ||
            (
              Object.prototype.hasOwnProperty.call(check.data, 'code') &&
              check.data.code !== 'auth/user-not-found'
            )
          )
        )
        {
          this.foundUserProfileStatus = 'ERROR'
          this.foundUserProfile = null
        }

        //
        // ADICIONA USUÁRIO NO GRUPO
        //

        else if (check.code === 1)
        {
          const foundUserID = String(check.data)
          const user = await getUserByUserID(foundUserID)

          if (false === !!user)
          {
            this.foundUserProfileStatus = 'WAITING'
            this.foundUserProfile = null

            this.showMessage('Atenção!', 'O e-mail foi encontrado, mas <b style="color: #FF0000">não foi possível carregar o perfil</b>. Por favor, tente novamente ou fale com o nosso suporte.')
          }
          else
          {
            this.foundUserProfile = {
              id: foundUserID,
              img: String(user?.img || '').indexOf('https://firebasestorage.googleapis.com/') !== -1 ? String(user?.img || '').trim() : userProfileBroken,
              nome: String(user?.nome || '').trim(),
              email: String(user?.email || '').trim(),
            }

            const isGroupMember = user?.grupos?.[this.groupID] || false

            this.foundUserProfileStatus = isGroupMember ? 'GROUP_MEMBER' : 'ADD_TO_GROUP'
          }
        }

        //
        // CRIA USUÁRIO E ADICIONA NO GRUPO
        //

        else if (check.code === 0 && Object.prototype.hasOwnProperty.call(check.data, 'code') && check.data.code === 'auth/user-not-found')
        {
          this.foundUserProfileStatus = 'CREATE_AND_ADD_TO_GROUP'
          this.foundUserProfile = null
        }

        //
        //
        //

        this.loading = false
      },

      //
      // CONVIDAR ou criar perfil do USUÁRIO
      //

      async inviteOrAddUser ()
      {
        if (this.loading) return false

        const nome = this.newUserName.trim()
        const senha = this.newUserPassword.trim()

        //
        // ADICIONAR USUÁRIO NO GRUPO
        //

        // INVITE OR ADD USER

        if (this.foundUserProfileStatus === 'ADD_TO_GROUP')
        {
          this.loading = true
          const addUserResult = await new Promise(resolve => { apiAddUserToGroup(this.foundUserProfile.id, this.groupID, addResponse => resolve(addResponse)) })
          this.loading = false

          if (addUserResult.code === 0) {
            this.showMessage('Ops!', 'Não foi possível adicionar o usuário no grupo!')
          } else {
            this.showMessage('Feito!', 'Usuário adicionado ao grupo!')
          }
        }

        //
        // CRIA UM NOVO USUÁRIO NA BASE E INSERE NO GRUPO
        //

        if (this.foundUserProfileStatus === 'CREATE_AND_ADD_TO_GROUP')
        {
          const errors = []

          if (nome.length === 0) errors.push('Informe o nome do usuário que será adicionado no grupo!')
          if (senha.length < 6) errors.push('Informe uma senha provisória com no mínimo 6 caracteres!')

          if (errors.length > 0) return this.showMessage('Ops!', errors.join('<br />'))

          this.loading = true

          const request = await apiCreateUser({
            origin: 'WEB',
            name: nome,
            email: this.newUserEmailLowerCase,
            password: senha,
            phone: '',
            crm: this.newUserCrm,
            groupID: this.groupID,
          })

          this.loading = false

          //
          // SHOW BACK-END RESPONSE
          //

          this.showMessage(request.title, request.httpCode === 201 ? 'O usuário foi criado e adicionado no grupo!' : request.message)
        }

        this.clearComponentState()
      },
    },
  }

</script>

<style scoped lang="scss">

  .foundUserTitle {
    margin-bottom: 10px;

    font-size: 20px;
    font-weight: 500;
    line-height: 25px;
  }

  .foundUserWrapper {
    position: relative;
  }

  .foundUser--image,
  .foundUser--data {
    display: inline-block;
    vertical-align: middle;
  }

  .foundUser--image {
    position: absolute;
    top: 0;
    width: 48px;
    height: 48px;
    border-radius: 7px;
    background-size: cover;
    background-color: #CCCCCC;
  }

  .foundUser--data {
    padding-left: 55px;

    word-break: break-all;
  }

  @media (max-width: 600px) {
    .foundUser--data {
      width: 100%;
    }
  }

  .searchFieldIcon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0 !important;
    left: 12px;
  }

  .searchField {
    width: 100%;
    // max-width: 320px;
    height: 100%;
    background-color: #ffffff;
    padding: 0 20px 0 40px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    outline: 0;
    // box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25);
    font-size: 15px;
    &:disabled {
      background-color: #CCCCCC;
    }
  }

  .searchBlock {
    position: relative;
    display: block;
    width: 100%;
    // max-width: 320px;
    height: 40px;
  }

  .searchLoading {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 25px;
    height: 25px;
  }

</style>
